import { LoaderCircle } from "lucide-react";
import { cn } from "@/lib/utils"; // Assuming you have a utility function for class merging

interface SpinnerProps {
  isRunningAction?: boolean;
  size?: number;
  className?: string;
}

export function Spinner({ isRunningAction = true, size = 16, className }: SpinnerProps) {
  return (
    <LoaderCircle
      className={cn(
        "animate-spin",
        isRunningAction ? "opacity-100" : "opacity-0",
        className
      )}
      size={size}
    />
  );
}
